export default {
  icon: 'business',
  name: 'Allumage/Arrêt',
  title: 'Allumage/Arrêt',
  update: {
    icon: 'edit',
    title: "Modifier les paramètres d'allumage",
  },
  create: {
    icon: 'mdi-plus',
    title: "Activer l'allumage à distance",
  },
  noItems:
    "Il n'y a pas de paramètrage Allumage/Arrêt en relation avec l'organisation et les filtres sélectionnés",
  fields: {
    createdAt: 'Créé le',
    controllers: "Pas d'automate",
    property: 'Installation',
    property_type: "Type de marché/d'usage",
    P1_meter_completeness: 'P1_meter_completeness',
    billing_meter_completeness: 'billing_meter_completeness',
    ECS_existence: 'ECS',
    ignition_capability: 'Eligibilité MyV',
    transmitter_type: 'Automatisme',
    communicating_transmitter: 'communicating_transmitter',
    TNC_label: 'TNC_label',
    TNC_value: 'TNC',
    heating_comand_label: 'heating_comand_label',
    PEM_action_validation: 'PEM_action_validation',
    REE_activation_validation: 'REE_activation_validation',
    REE_stop_validation: 'REE_stop_validation',
    agency_entity_comment: 'Commentaire',
    activation_type: 'Mode',
    created_at: 'created_at',
    activation_date: "Date d'allumage",
    stop_date: "Date d'arret",
    status: 'État MyV',
    actions: 'Actions',
  },
  computedFields: {
    validation: 'Validation Allumage/Arrêt',
  },
  subtitle: {
    param: 'Paramétrage',
    follow: 'Suivi des saisons en cours',
  },
};
